import { generateBooleanSchema, generateRootObjectSchema, generateStringSchema, generateArraySchema, generateObjectSchema, generateNumberSchema, generateColorSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";

export const specification = new BaseAtomSpec("Wagon Wheel Card", generateRootObjectSchema({
    container: generateAtomContainerSchema({
        defaultValues: {
          themeMode: 'primary',
        },
      }),
      cardTitle: generateStringSchema('Card Title', 'Main heading for wagon wheel card', {
        defaultValue: 'Wagon Wheel',
      }),
      scoringBreakdownLabel: generateStringSchema('Breakdown Label', 'Label above filter chips', {
        defaultValue: 'Scoring Breakdown',
      }),
      sharedFontFamily: generateStringSchema('Shared Font Family', 'Shared font family for all Wagon Wheel card text'),
      tabs: generateArraySchema(
        'Tabs',
        'Wagon wheel tabs for innings/team states',
        generateObjectSchema('Tab', 'Single wagon wheel tab entry', {
          id: generateStringSchema('Id', 'Tab identifier'),
          label: generateStringSchema('Label', 'Tab label, e.g. TRI1 1ST'),
          totalRuns: generateNumberSchema('Total Runs', 'Total runs value shown in side panel', { defaultValue: 0 }),
          breakdown: generateArraySchema(
            'Breakdown',
            'Filter chips and counts',
            generateObjectSchema('Breakdown Item', 'Single scoring chip', {
              key: generateStringSchema('Key', 'all, 1, 2, 3, 4, 6, wicket, wide, noball'),
              label: generateStringSchema('Label', 'Display label for chip'),
              count: generateNumberSchema('Count', 'Shot count for chip', { defaultValue: 0 }),
            })
          ),
          shots: generateArraySchema(
            'Shots',
            'Shot spokes to render on wheel',
            generateObjectSchema('Shot', 'Single wagon wheel shot', {
              angle: generateNumberSchema('Angle', "Clockwise from 12 o'clock", { defaultValue: 0 }),
              length: generateNumberSchema('Length', 'Relative spoke length', { defaultValue: 0 }),
              runs: generateNumberSchema('Runs', 'Runs scored off delivery', { defaultValue: 0 }),
              isBoundary: generateBooleanSchema('Is Boundary', 'Boundary flag'),
              isWicket: generateBooleanSchema('Is Wicket', 'Wicket flag'),
              isWide: generateBooleanSchema('Is Wide', 'Wide flag'),
              isNoBall: generateBooleanSchema('Is No Ball', 'No-ball flag'),
            })
          ),
        })
      ),
      scoreMarkerColor: generateColorSchema('Score Marker Color', 'Color for outer score labels'),
      scoringBreakdownLabelColor: generateColorSchema(
        'Scoring Breakdown Label Color',
        'Color for scoring breakdown heading text'
      ),
      groundColor: generateColorSchema('Ground Color', 'Main field fill color', {
        defaultValue: '#2e8e35',
      }),
      boundaryBandColor: generateColorSchema('Boundary Band Color', 'Boundary ring color'),
      outerRingColor: generateColorSchema('Outer Ring Color', 'Outer frame ring color', {
        defaultValue: '#e5e5e5',
      }),
      innerCircleColor: generateColorSchema('Inner Circle Color', 'Inner circle stroke color', {
        defaultValue: '#E5C883',
      }),
      pitchColor: generateColorSchema('Pitch Color', 'Pitch color', {
        defaultValue: '#b5a05a',
      }),
      oneRunColor: generateColorSchema('1s Color', 'Chip and shotline color for 1 run', {
        defaultValue: '#0077C2',
      }),
      twoRunColor: generateColorSchema('2s Color', 'Chip and shotline color for 2 runs', {
        defaultValue: '#BC5120',
      }),
      threeRunColor: generateColorSchema('3s Color', 'Chip and shotline color for 3 runs', {
        defaultValue: '#6215C1',
      }),
      fourRunColor: generateColorSchema('4s Color', 'Chip and shotline color for 4 runs', {
        defaultValue: '#3861E0',
      }),
      sixRunColor: generateColorSchema('6s Color', 'Chip and shotline color for 6 runs', {
        defaultValue: '#CA11D0',
      }),
      wicketColor: generateColorSchema('Wicket Color', 'Chip and shotline color for wicket', {
        defaultValue: '#E12828',
      }),
}));